import { Stack, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Intro, MobileIntro } from "src/assets";
import BoldTitle from "src/components/Displays/BoldTitle";
import MobileTitle from "src/components/Displays/MobileTitle";
import { useContext } from "react";
import { Logo, LogoSMA } from "src/assets";
import { ThemeValues } from "src/components/ThemeUsage/theme";
import { ThemeContext } from "src/components/ThemeUsage/ThemeUsage";

const Header = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const themeName = useContext(ThemeContext);
  const getLogo = () => {
    switch (themeName) {
      case ThemeValues.SMA:
        return <LogoSMA />;
      case ThemeValues.default:
        return <Logo color={"black"} />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <Stack
        sx={(theme) => ({
          color: theme.palette.grey[500],
          width: "100%",
          py: 4,
          px: 4,
          maxWidth: "850px",
        })}
      >
        {getLogo()}
      </Stack>

      <Stack
        sx={{
          alignItems: "center",
          width: "fit-content",
          height: "fit-content",
          maxHeight: "fit-content",
          position: "relative",
          borderRadius: "15px",
          overflow: "hidden",
        }}
      >
        <Stack
          sx={{
            display: { xs: "none", sm: "flex" },
          }}
        >
          <img
            src={Intro}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          sx={{
            display: { xs: "flex", sm: "none" },
          }}
        >
          <img
            src={MobileIntro}
            alt="mobile-intro"
            style={{
              width: "100%",
              height: "100%",
            }}
          />
          <Stack
            sx={{
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "250px",
              background:
                "linear-gradient(to top, rgba(0, 0, 0, 0.888), transparent)",
            }}
          />
        </Stack>
        <Stack
          gap={6}
          sx={{
            maxWidth: "350px",
            position: "absolute",
            left: { lg: "201px", md: "100px", sm: "0px" },
            bottom: "29px",
            px: { xs: 4, lg: 0 },
          }}
        >
          <BoldTitle
            color={theme.palette.app.contrast}
            sx={{
              fontSize: { xs: "36px", sm: "48px" },
              lineHeight: { xs: "39px", sm: "50px" },
            }}
            text={t("page.introduction.newIntroductionTitle")}
          />
          <MobileTitle
            text={t("page.introduction.subtitle")}
            color={theme.palette.app.contrast}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default Header;
